module.exports = __webpack_public_path__ + "static/media/MobilePhoneGoogle.21d9afcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MobilePhoneGoogle.png
// module id = 6158
// module chunks = 1